/* Fellino storefront. Native Shopify forms preserve app validation and line-item properties. */
(() => {
  'use strict';
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];
  const shopRoot = () => window.Shopify?.routes?.root || '/';
  const notify = (message) => {
    const box = qs('.fl-notice');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    clearTimeout(box._timer);
    box._timer = setTimeout(() => { box.hidden = true; }, 7000);
  };
  function initNavigation(root = document) {
    qsa('.fl-nav-group, .fl-mobile-menu', root).forEach(detail => {
      if (detail.dataset.initialized) return;
      detail.dataset.initialized = 'true';
      detail.addEventListener('toggle', () => {
        if (!detail.open || detail.classList.contains('fl-mobile-menu')) return;
        qsa('.fl-nav-group', detail.parentElement).forEach(other => { if (other !== detail) other.open = false; });
      });
    });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    const parent = active?.closest('.f3-nav-subgroup[open], .fl-nav-group[open], .fl-mobile-menu[open]');
    if (parent) { parent.open = false; qs('summary', parent)?.focus(); }
    else qsa('.f3-nav-subgroup[open], .fl-nav-group[open], .fl-mobile-menu[open]').forEach(detail => { detail.open = false; });
  });
  document.addEventListener('click', event => {
    // Anchor navigation does not reload the page: dismiss the menu before the native jump.
    const mobileLink = event.target.closest('.fl-mobile-panel a[href]');
    if (mobileLink && !event.defaultPrevented && event.button === 0 &&
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
        (!mobileLink.target || mobileLink.target === '_self') && !mobileLink.hasAttribute('download')) {
      const menu = mobileLink.closest('.fl-mobile-menu');
      if (menu) menu.open = false;
    }
    qsa('.f3-nav-subgroup[open], .fl-nav-group[open], .fl-mobile-menu[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });

  });
  function initPrivacy(root = document) {
    qsa('[data-cookie-preferences]', root).forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      button.addEventListener('click', async event => {
        event.preventDefault();
        try {
          for (let attempt = 0; attempt < 20 && !window.privacyBanner?.showPreferences; attempt++) {
            await new Promise(resolve => setTimeout(resolve, 150));
          }
          if (window.privacyBanner?.showPreferences) await window.privacyBanner.showPreferences();
          else notify(document.body.getAttribute('data-cookie-loading'));
        } catch { notify(document.body.getAttribute('data-cookie-error')); }
      });
    });
  }
  function initSearch(root = document) {
    const input = qs('#FellinoSearch', root);
    if (!input || input.dataset.initialized) return;
    input.dataset.initialized = 'true';
    const panel = qs('#FellinoSuggestions', input.form);
    const status = qs('[data-search-status]', input.form);
    const stringsNode = qs('[data-search-strings]', input.form);
    if (!stringsNode) return;
    const strings = JSON.parse(stringsNode.textContent);
    const phrase=(key,name,value)=>strings[key].replace(name,String(value));
    const cache = new Map(); let timer, controller;
    const close = () => { panel.hidden = true; };
    const link = (text, url, imageUrl) => {
      const a = document.createElement('a');
      const target = new URL(url, location.origin);
      if (target.origin !== location.origin && !target.hostname.endsWith('.myshopify.com')) return null;
      a.href = target.pathname + target.search;
      if (imageUrl) {
        const img = document.createElement('img'); img.src = imageUrl; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy'; a.append(img);
      }
      const title = document.createElement('span'); title.textContent = text; a.append(title); return a;
    };
    function render(data, term) {
      if (input.value.trim() !== term) return;
      panel.replaceChildren();
      const products = (data.resources?.results?.products || []).filter(product => !product.handle?.startsWith('fellino-zubehoerbundle-') && !product.url?.includes('/products/fellino-zubehoerbundle-'));
      const collections = data.resources?.results?.collections || [];
      let count = 0;
      for (const [title, items] of [[strings.products, products], [strings.categories, collections]]) {
        if (!items.length) continue;
        const heading = document.createElement('h2'); heading.textContent = title; panel.append(heading);
        const ul = document.createElement('ul');
        items.forEach(item => {
          const a = link(item.title, item.url, item.featured_image?.url || (typeof item.image === 'string' ? item.image : null));
          if (!a) return;
          const li = document.createElement('li'); li.append(a); ul.append(li); count++;
        });
        panel.append(ul);
      }
      const all = link(phrase(count?'all':'query','__term__',term), `${shopRoot()}search?q=${encodeURIComponent(term)}&type=product`);
      if (all) panel.append(all);
      status.textContent = phrase('available','__count__',count);
      panel.hidden = false;
    }
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort(); close();
      const term = input.value.trim(); if (term.length < 2) return;
      timer = setTimeout(async () => {
        if (cache.has(term)) { render(cache.get(term), term); return; }
        controller = new AbortController();
        try {
          const url = new URL(`${shopRoot()}search/suggest.json`, location.origin);
          url.searchParams.set('q', term); url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit]', '5'); url.searchParams.set('resources[options][unavailable_products]', 'last');
          const response = await fetch(url, {signal:controller.signal});
          if (!response.ok) return;
          const data = await response.json(); if (cache.size > 20) cache.clear(); cache.set(term, data); render(data, term);
        } catch (error) { if (error.name !== 'AbortError') close(); }
      }, 220);
    });
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' && !panel.hidden) { e.preventDefault(); qs('a', panel)?.focus(); }
    });
    panel.addEventListener('keydown', e => {
      const links = qsa('a', panel); const i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (links[i + 1] || links[0])?.focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (links[i - 1] || input).focus(); }
      if (e.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', e => { if (!input.form.contains(e.target)) close(); });
    input.form.addEventListener('focusout', () => setTimeout(() => { if (!input.form.contains(document.activeElement)) close(); }, 0));
  }
  function initRecommendations(root = document) {
    qsa('[data-recommendations]', root).forEach(node => {
      if (node.dataset.initialized) return; node.dataset.initialized = 'true';
      const load = async () => {
        try {
          const response = await fetch(node.dataset.url); if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = qs('[data-recommendations]', html);
          if (content?.querySelector('.fl-card')) node.replaceChildren(...content.childNodes);
          else node.hidden = true;
        } catch { /* An optional recommendation must never prevent shopping. */ }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { observer.disconnect(); load(); } }, {rootMargin:'300px'}); observer.observe(node);
      } else load();
    });
  }
  function initSort(root = document) {
    qsa('[data-sort-by]', root).forEach(select => {
      if (select.dataset.initialized) return; select.dataset.initialized = 'true';
      const sort = () => { const url = new URL(location.href); if (select.value === 'discount-desc') { url.searchParams.set('fellino_sort', 'discount-desc'); url.searchParams.set('sort_by', 'title-ascending'); } else { url.searchParams.set('sort_by', select.value); url.searchParams.delete('fellino_sort'); } url.searchParams.delete('page'); url.searchParams.delete('discount_page'); location.assign(url); };
      select.addEventListener('change', sort);
      select.form?.addEventListener('submit', event => { event.preventDefault(); sort(); });
    });
  }
  function initCatalog(root = document) {
    qsa('.fc-filter-sidebar .fl-filters', root).forEach(node => { if (!node.dataset.retailReady) { node.open = matchMedia('(min-width: 1000px)').matches; node.dataset.retailReady = 'true'; } });
    qsa('[data-catalog-view]', root).forEach(button => { if (button.dataset.initialized) return; button.dataset.initialized = 'true'; button.addEventListener('click', () => { const container = button.closest('.fc-catalog-main'); container.classList.toggle('fc-list-view', button.dataset.catalogView === 'list'); qsa('[data-catalog-view]', container).forEach(item => item.setAttribute('aria-pressed', String(item === button))); }); });
  }
  function initArticle(root = document) {
    qsa('[data-article-content]', root).forEach(content => {
      if (content.dataset.initialized) return;
      content.dataset.initialized = 'true';
      const toc = qs('[data-article-toc]');
      const list = toc?.querySelector('ol');
      const headings = qsa('h2', content);
      if (!list || headings.length < 2) return;
      headings.forEach((heading, index) => {
        if (!heading.id) { let id = `fellino-abschnitt-${index + 1}`; while (document.getElementById(id)) id += '-a'; heading.id = id; }
        const item = document.createElement('li'); const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id); link.textContent = heading.textContent;
        item.append(link); list.append(item);
      });
      toc.hidden = false;
    });
  }
  function initFooter(root) {
    qsa('.fl-footer-group', root).forEach(group => {
      if (group.dataset.footerReady) return;
      group.dataset.footerReady = 'true';
      const desktop = window.matchMedia('(min-width: 1000px)');
      const update = () => { group.open = desktop.matches; };
      update();
      const onChange = () => {
        if (!group.isConnected) { desktop.removeEventListener('change', onChange); return; }
        update();
      };
      desktop.addEventListener('change', onChange);
    });
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('.jdgm-prev-badge, a[href="#judgeme_product_reviews"]')) return;
    const panel = qs('[data-product-reviews]');
    if (panel) panel.open = true;
  }, true);
  const openReviewAnchor = () => {
    if (/^#(?:judgeme|reviews)/.test(location.hash)) {
      const panel = qs('[data-product-reviews]');
      if (panel) { panel.open = true; panel.scrollIntoView({block:'start'}); }
    }
  };
  window.addEventListener('hashchange', openReviewAnchor);
  function init(root = document) { openReviewAnchor(); initFooter(root); initArticle(root); initNavigation(root); initCatalog(root); initPrivacy(root); initSearch(root); initRecommendations(root); initSort(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
